import { composeIO } from 'react-compose-io'
import { graficoValorQuantidadeIO } from './GraficoValorQuantidade.IO'
import { GraficoValorQuantidadeView } from './GraficoValorQuantidade.View'

export const GraficoValorQuantidade = composeIO(GraficoValorQuantidadeView, graficoValorQuantidadeIO)
